import React from 'react'
import { assets } from '../../../Assets/assets'

const GetInTouch = () => {
  return (
    <section>
      <div className='xl:pb-20 py-6 px-6 grid gap-10 grid-cols-1 lg:grid-cols-2 xl:px-20'>
        <figure className='md:h-full h-[50vh] w-full rounded-2xl overflow-hidden'><img className='object-cover object-center h-full w-full' src={assets.getInTouchBanner} alt="" /></figure>
        <div>
          <p className='text-2xl md:text-3xl lg:text-5xl font-medium text-primaryTextColor'>Get In Touch</p>
          <p className='text-gray-500 text-sm py-3 mb-3'>We'd love to hear from if you have any question</p>
          <div>
            <form action="" className='grid grid-cols-2 gap-3 items-center'>

              <div className='grid gap-2 items-center'>
                <label htmlFor="" className='font-medium text-sm sm:text-md'>First Name</label>
                <input type="text" placeholder='First Name' className='placeholder-gray-500 px-3 py-2 rounded-lg border  w-full placeholder:text-sm' />
              </div>
              <div className='grid gap-2 items-center'>
                <label htmlFor="" className='font-medium text-sm sm:text-md'>Last Name</label>
                <input type="text" placeholder='Last Name' className='placeholder-gray-500 px-3 py-2 rounded-lg border w-full placeholder:text-sm' />
              </div>
              <div className='grid gap-2 items-center'>
                <label htmlFor="" className='font-medium text-sm sm:text-md'>Email</label>
                <input type="email" placeholder='Email' className='placeholder-gray-500 px-3 py-2 rounded-lg border w-full placeholder:text-sm' />
              </div>
              <div className='grid gap-2 items-center'>
                <label htmlFor="" className='font-medium text-sm sm:text-md'>Phone Number</label>
                <input type='number' placeholder='Enter Your Phon number ' className='placeholder-gray-500 px-3 py-2 rounded-lg border w-full placeholder:text-sm' />
              </div>
              <div className='col-span-2 '>
                <label htmlFor="" className='font-medium text-sm sm:text-md'> Message</label>
                <textarea name="" id="" placeholder='Your Message' rows={4} className='w-full placeholder-gray-500 placeholder:text-sm px-3 py-2 rounded-lg border'>
                </textarea>
              </div>
            </form>
            <div className='flex items-center justify-center mt-5'>
              <button className='bg-black rounded-lg py-2 transition-colors duration-300 px-3 w-full text-white  hover:bg-[#E4E95B] hover:text-black font-medium'>
                <span className='text-xs  sm:text-md md:text-lg'>Send Message</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GetInTouch